// Libraries
import { MinusIcon } from '@chakra-ui/icons';
import { IconButton } from '@chakra-ui/react';
// Components
import { RoundedCheckIcon } from '@atoms/Icons';
// Types
import { CheckboxProps } from './Checkbox.types';

/**
 * Checkbox component that displays a checkbox icon based on the selection state.
 *
 * @component
 * @param {CheckboxProps} props - The component props.
 * @param {CheckboxProps} props.isSelected - Specifies whether the checkbox is selected or not.
 * @param {CheckboxProps} props.isPartial - This is used when not all options are selected.
 * @param {CheckboxProps} props.label - The label or text associated with the checkbox.
 * @returns {ReactElement} The Checkbox component.
 */
export const Checkbox = ({ isSelected, isPartial, label, color = 'white', ...rest }: CheckboxProps) => {
  const colorScheme = isSelected ? 'submitScheme' : 'transparentScheme';
  const border = isSelected ? 'none' : 'greyCheck';

  return (
    <IconButton
      w={4}
      minW={4}
      h={4}
      aria-label={label}
      colorScheme={colorScheme}
      border={border}
      borderRadius='base'
      icon={
        isSelected ? (
          isPartial ? (
            <MinusIcon w={2.5} h={2.5} color={color} />
          ) : (
            <RoundedCheckIcon w={2.5} h={2.5} color={color} />
          )
        ) : undefined
      }
      {...rest}
    />
  );
};
